import { ComponentPropsWithoutRef, forwardRef } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import styles from "./styles.module.scss";
import { ReactComponent as OutlineSearch16 } from "assets/svg/outline-search-16.svg";
import getClasses from "utils/getClasses";

type Props = Omit<ComponentPropsWithoutRef<typeof FormControl>, "type"> & {
  search: string;
  code?: Record<string, string>;
  show: boolean;
};
// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const ForwardedInputToggle = forwardRef<HTMLInputElement | null, Props>(
  function InputToggle(
    {
      code,
      search,
      show,
      onToggle,
      className = "",
      onClick,
      readOnly,
      ...props
    },
    ref,
  ) {
    return (
      <InputGroup
        ref={ref}
        className={getClasses(
          styles["input-toggle"],
          readOnly && styles["input-toggle--readOnly"],
          className,
        )}
        onClick={(e) => (readOnly ? null : onClick(e))}
      >
        <FormControl
          className={getClasses(styles["input-toggle__input"], className)}
          type={"text"}
          value={(show ? search : code?.id) || ""}
          readOnly={readOnly}
          {...props}
        />
        {(readOnly || !show) && (
          <div className={styles["input-toggle__description"]}>
            {code?.description}
          </div>
        )}

        <InputGroup.Text
          className={getClasses(
            styles["input-toggle__append"],
            styles["input-toggle__search"]
          )}
        >
          {!readOnly && (
            <OutlineSearch16
              className={styles["input-toggle__search-icon"]}
            />
          )}
        </InputGroup.Text>
      </InputGroup>
    );
  },
);

export default ForwardedInputToggle;
